import MUIButton from '@/components/MUI-Components/MUI-Button';
import CloseIcon from '@mui/icons-material/Close';
import React, {memo} from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import {careerFormLink} from '@/constants';
import {colors, fontFamily, fontSize, fontWeight, spacing, borderRadius} from '@/styles/tokens';

const jobTitleSx = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: `${spacing[20]} !important`
} as const;

const jobSubTitleSx = {padding: `0 ${spacing[20]} !important`} as const;

const jobCloseTitleSx = {
    fontSize: `${fontSize[40]} !important`,
    fontWeight: `${fontWeight.bold} !important`,
    color: '#717171 !important',
    cursor: 'pointer !important'
} as const;

const jobTitleHeadingSx = {
    fontFamily: `${fontFamily.body} !important`,
    color: '#332f2f',
    fontSize: `${fontSize[32]} !important`
} as const;

const jobTitleSubHeadingSx = {
    fontFamily: `${fontFamily.body} !important`,
    fontSize: `${fontSize[20]} !important`,
    padding: '6px 0 !important',
    '& span': {color: '#254285 !important'}
} as const;

const jobDescriptionHeadingSx = {
    '& p': {
        color: '#fc9b02 !important',
        fontSize: `${fontSize[22]} !important`,
        padding: `20px ${spacing[20]} 0 ${spacing[20]} !important`
    }
} as const;

const jobDescriptionListSx = {
    paddingLeft: `${spacing[8]} !important`,
    paddingRight: `${spacing[8]} !important`,
    '& ul li': {
        fontFamily: `${fontFamily.body} !important`,
        padding: '10px 0 !important'
    }
} as const;

const jobDetailBtnSx = {
    textAlign: 'center !important',
    padding: `${spacing[12]} 0px ${spacing[20]} 0px !important`,
    '& button': {
        background: `${colors.primary.main} !important`,
        fontSize: `${fontSize[20]} !important`,
        borderRadius: `${borderRadius.lg} !important`,
        padding: '10px 30px !important',
        fontFamily: `${fontFamily.body} !important`,
        textTransform: 'capitalize !important'
    }
} as const;

const OpportunityDetails = (props: any) => {
    const {jobData, handleClose} = props;
    return (
        <Box className="opportunity-details-wrapper">
            <Box className="opportunity-details-inner">
                <Box sx={jobTitleSx}>
                    <Typography sx={jobTitleHeadingSx}>{jobData.label}</Typography>
                    <CloseIcon sx={jobCloseTitleSx} onClick={handleClose} />
                </Box>
                <hr />
                <Box sx={jobSubTitleSx}>
                    <Typography sx={jobTitleSubHeadingSx}>
                        <span>Qualification:</span>&nbsp;{jobData.qualification}
                    </Typography>
                    <Typography sx={jobTitleSubHeadingSx}>
                        <span>Experience</span>:&nbsp;{jobData.experience} Years
                    </Typography>
                </Box>
                <hr />
            </Box>
            <Box className="job-description">
                <Box sx={jobDescriptionHeadingSx}>
                    <Typography>Job Description</Typography>
                </Box>
                <Box sx={jobDescriptionListSx}>
                    <ul>
                        {jobData.description?.map((item: string, index: number) => (
                            <li key={index}>{item}</li>
                        ))}
                    </ul>
                </Box>
            </Box>
            <hr />
            <Box
                onClick={() => {
                    handleClose();
                    globalThis.open(careerFormLink, '_blank');
                }}
                className="footer-link test1"
            >
                <Box sx={jobDetailBtnSx}>
                    <MUIButton className="nav-button" variant="contained" label="Apply Now" />
                </Box>
            </Box>
        </Box>
    );
};

export default memo(OpportunityDetails);
